import React from 'react'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './MobileView.scss'


type MobileView = {
  text: Notifications.Item['text']
  onHide: () => void
}

const MobileView: React.FunctionComponent<MobileView> = ({ text, onHide }) => (
  <Box className={s.container} alignCenter>
    <button
      className={s.notification}
      type="button"
      onClick={onHide}
    >
      <Box ph={24} pv={12} inline noWrapper>
        <Text message={text} size="16-24" color="white" semibold />
      </Box>
    </button>
  </Box>
)


export default MobileView
